import '../public/global.css';
import { mount } from 'svelte'; // Import mount from svelte
import App from './App.svelte';

// Use mount for Svelte 5 initialization
const app = mount(App, {
	target: document.body,
	props: {}
});

export default app;